import qs from 'qs';
import { network } from 'services/network';

export const setVisibilityMode = ({ viewId, hide }: QueryParams) => {
    const querystring = qs.stringify({ viewId, hide }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/setVisibilityMode${querystring}`;
    return network.post(url).then((response) => response.data);
};

export interface QueryParams {
    viewId: number;
    hide: boolean;
}
